import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { UserInfoProjectorImpl } from "types/api/userInfoProjectorImpl";

import "./MentionList.less";

type Props = {
  items: UserInfoProjectorImpl[];
  command: ({ id, label }: { id: number | string; label: string }) => void;
};

type Ref = {
  onKeyDown: ({ event }: { event: KeyboardEvent }) => boolean;
};

export default forwardRef<Ref, Props>((props, ref) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const listContainerRef = useRef<HTMLDivElement>(null);

  const selectItem = (index: number) => {
    const item = props.items[index];

    if (item) {
      props.command({ id: item.id!, label: item.displayName! });
    }
  };

  const upHandler = () => {
    setSelectedIndex(
      (selectedIndex + props.items.length - 1) % props.items.length,
    );
  };

  const downHandler = () => {
    setSelectedIndex((selectedIndex + 1) % props.items.length);
  };

  const enterHandler = () => {
    selectItem(selectedIndex);
  };

  useEffect(() => setSelectedIndex(0), [props.items]);

  useEffect(() => {
    if (listContainerRef.current) {
      const button = listContainerRef.current.querySelector(
        `[data-index='${selectedIndex}']`,
      );
      if (button) {
        (button as HTMLButtonElement).scrollIntoView({ block: "nearest" });
      }
    }
  }, [selectedIndex]);

  useImperativeHandle(ref, () => ({
    onKeyDown: ({ event }) => {
      if (event.key === "ArrowUp") {
        upHandler();
        return true;
      }

      if (event.key === "ArrowDown") {
        downHandler();
        return true;
      }

      if (event.key === "Enter") {
        enterHandler();
        return true;
      }

      return false;
    },
  }));

  return (
    <div className="tip-tap-mention-dropdown" ref={listContainerRef}>
      {props.items.length ? (
        props.items.map((item, index) => (
          <button
            className={index === selectedIndex ? "is-selected" : ""}
            key={index}
            onClick={() => selectItem(index)}
            data-index={index}
          >
            {item.displayName}
          </button>
        ))
      ) : (
        <div className="item">No result</div>
      )}
    </div>
  );
});
